import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TherapistAuthStateService } from '@therapist/shared/services/state/therapist-auth-state.service';

const checkAuth = (stateUrl?: string): true | UrlTree => {
  const auth = inject(TherapistAuthStateService);
  const router = inject(Router);

  if (auth.hasValidToken()) {
    return true;
  }

  console.warn('No valid token found in AuthGuard, redirecting to login');

  // Optional: Redirect mit Rücksprung-URL
  return router.createUrlTree(
    ['/login'],
    stateUrl ? { queryParams: { redirect: stateUrl } } : undefined
  );
};

export const therapistAuthCanActivate: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => checkAuth(state.url);

export const therapistAuthCanActivateChild: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => checkAuth(state.url);

export const therapistAuthCanMatch: CanMatchFn = () => checkAuth();
